<template>
    <div>
        <b-alert v-if="findingLocation" show variant="info">{{ $t('sandoz.geolocation_loading_msg') }}</b-alert>
        <b-alert v-else-if="!findingLocation && error" show variant="warning">{{ $t('sandoz.geolocation_error_msg', { message: error }) }}</b-alert>
        <b-row class="contract_detail" v-if="metaData && metaData.contract">
            <div class="col-sm mb-3 mwp-100">
                <o-form-group :label="$t('sandoz.year')" class="d-inline align-top">
                    <div v-if="metaData.contract"
                            :class="{'badge badge-danger': (new Date()).getYear()+1900 != metaData.contract.contract_year}">
                        {{metaData.contract.contract_year}}
                    </div>
                </o-form-group>
            </div>
            <div class="col-sm mb-3 mw-200 d-md-none"
                    v-if="hasPermission(['GET api/contracts/{id}/pdf']) && metaData.contract">

                <o-form-group :label="$t('sandoz.contract')" class="d-inline align-top float-right">
                <template v-for="(contract_number,contract_id) in metaData.contract.contracts">
                    <div> {{contract_number}}
                    <a style="color: rgb(0, 97, 171);" :title="$t('sandoz.contract_pdf')" @click="pdfContract(contract_id)">
                        <fa icon="download"/> {{$t('sandoz.pdf')}}
                    </a>
                    </div>
                </template>
                </o-form-group>
            </div>
            <div class="col-sm mb-3">
                <o-form-group :label="$t('sandoz.name')" class="d-inline align-top">
                    <div class="text-pre"
                            v-html="metaData.contract && metaData.contract.name ? metaData.contract.name : ''">
                    </div>
                </o-form-group>
            </div>
            <div class="col-sm mb-3 d-none d-sm-block">
                <o-form-group :label="$t('sandoz.address')" class="d-inline align-top">
                    <div class="text-pre"
                            v-html="metaData.contract && metaData.contract.address ? metaData.contract.address : ''">
                    </div>
                </o-form-group>
            </div>
            <div class="col-sm mb-3 d-none d-md-block"
                    v-if="hasPermission(['GET api/contracts/{id}/pdf']) && metaData.contract">
                <o-form-group :label="$t('sandoz.contract')" class="d-inline align-top float-right">
                    <template v-for="(contract_number,contract_id) in metaData.contract.contracts">
                        <div>{{contract_number}}
                        <a style="color: rgb(0, 97, 171);" :title="$t('sandoz.contract_pdf')" @click="pdfContract(contract_id)">
                            <fa icon="download"/> {{$t('sandoz.pdf')}}
                        </a>
                        </div>
                    </template>
                </o-form-group>
            </div>
        </b-row>

        <o-table customDivClass="verificationNew" v-if="!findingLocation" ref="tableList" :title="$t('sandoz.verifications')"
                     :url="'/api/verifications-new/contracts/' + $route.params.id + '/' + $route.params.year + '/' + $route.params.address + '?include=product.productMaster,contract_line.deliveries&lat=' + latitude + '&long=' + longitude" @loaded="setMeta"
                     default-sort-by="planned_from" :enable-delete="false" :enable-new="false" :enable-edit="false" :grey-row="isUpcoming" :red-row="isPast">
            <template slot="filter">
                <o-filter :default-filter="defaultFilter" v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
                    <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
                    <o-filter-select :items="dateStatus" :title="$t('sandoz.date')" column="planned_verification">
                    </o-filter-select>
                    <!-- <o-filter-select :items="deliveryDelay" :title="$t('sandoz.ignore_delivery_delay')" column="ignore_delivery_delay">
                    </o-filter-select> -->
                    <o-filter-select :items="types" :title="$t('sandoz.type')" column="contract_type"></o-filter-select>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="contract_type"  v-if="metaData && metaData.contract && Object.keys(metaData.contract.contracts).length > 1">{{ $t('sandoz.contract_type') }}</o-table-header>
                <o-table-header column="product_name">{{ $t('sandoz.product_name') }}</o-table-header>
                <template  v-if="metaData && metaData.contract && ( metaData.contract.is_kam === true || metaData.contract.is_kam === 'mixed')">
                    <o-table-header column="quantity">{{ $t('sandoz.quantity') }}</o-table-header>
                    <o-table-header column="comment">{{ $t('sandoz.comment') }}</o-table-header>
                </template>
                <o-table-header column="planned_from">{{ $t('sandoz.date_from') }}</o-table-header>
                <o-table-header column="planned_to">{{ $t('sandoz.date_to') }}</o-table-header>
                <o-table-header></o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td :data-label="$t('sandoz.contract_type')" v-if="metaData && metaData.contract && Object.keys(metaData.contract.contracts).length > 1">{{ displayContractType(props.item.contract_type)}}</td>
                <template v-if="showQuantity(props.item) && (metaData.contract.is_kam === false || metaData.contract.is_kam === 'mixed')">
                    <td :data-label="$t('sandoz.product_name')"> 
                        <a href="javascript:void(0);" @click="openDeliveryModel(props.item)" :title="$t('sandoz.deliveries')">
                            {{
                                props.item.product_name ? props.item.product_name : ''
                            }}
                            <fa icon="info-circle"/>
                        </a>
                    </td>
                </template>
                <template v-else>
                    <td :data-label="$t('sandoz.product_name')">
                    {{
                        props.item.product_name ? props.item.product_name : ''
                    }}
                    </td>
                </template>
                <template v-if="metaData && metaData.contract && (metaData.contract.is_kam === true || metaData.contract.is_kam === 'mixed')">
                    <td :data-label="$t('sandoz.quantity')">{{ props.item.quantity}}</td>
                    <td :data-label="$t('sandoz.comment')">{{ props.item.comment}}</td>
                </template>
                <td :data-label="$t('sandoz.date_from')">{{ props.item.planned_from | formatDate }}</td>
                <td :data-label="$t('sandoz.date_to')">{{ props.item.planned_to | formatDate }}</td>
                <td class="text-right">
                    <div :ref="'controls_' + props.item.verification_proof_id" aria-label="edit controls" class="btn-group btn-group-sm"
                         role="group">
                        <span class="badge badge-success mr-1 text-capitalize" v-if="props.item.status === 'verified'">
                          {{ props.item.status }}<br>
                          {{ props.item.actual_verification | formatDate }}
                        </span>
                        <span class="badge badge-warning mr-1 text-capitalize" v-if="props.item.status === 'failed'">
                          {{ props.item.status }}<br>
                          {{ props.item.actual_verification | formatDate }}
                        </span>
                        <template v-if="props.item.status === 'upcoming'">
                            <b-badge variant="warning">{{ $t('sandoz.future_item')}}</b-badge>
                        </template>
                        <template v-else>
                            <o-button v-if="props.item.status === 'failed' || props.item.status === 'pending' || props.item.status === 'verified'" native-type="button" variant="primary"
                                    @click="openAllowModel(props.item)">
                            {{ props.item.status === 'pending' || props.item.status === 'failed' ? $t('sandoz.allow'): $t('sandoz.allow_more_pictures')  }}
                            </o-button>
                            <o-button v-if="props.item.status !== 'failed'" native-type="button" variant="warning"
                                    @click="openDenyModel(props.item)">
                            {{ $t('sandoz.deny') }}
                            </o-button>
                            <o-button native-type="button" variant="secondary" :title="$t('sandoz.title_verification_pictures')"
                                    @click="openPictureOverlay(props.item)"><fa icon="images"/>
                            </o-button>
                        </template>
                    </div>
                </td>

                <b-modal id="modal-allow" ref="allowModel" :no-close-on-backdrop="true" :no-close-on-esc="true"
                         :ok-only="true" :ok-title="$t('core.cancel')" :title="props.item.status === 'pending' ? $t('sandoz.allow'): ''" size="md"
                         @close="closeAllowModel">
                    <template v-if="!findingLocation">
                        <b-alert show variant="warning" v-if="locationFarAway">{{ $t('sandoz.location_far_away') }}</b-alert>
                        <b-alert show variant="warning" v-if="validToPast">{{ $t('sandoz.proof_past') }}</b-alert>
                        <o-textarea v-model="note" :label="$t('core.note')"></o-textarea>
                        <div class="mb-2 mt-3">{{ $t('sandoz.upload_file') }}</div>
                        <span v-if="!findingLocation && latitude &&
                            longitude &&
                            props.item && props.item.product &&
                            props.item.product.data &&
                            props.item.product.data.productMaster &&
                            props.item.product.data.productMaster.data"
                                class="badge badge-warning mb-3 mb-3">
                        </span>
                        <dropzone :id="''+props.item.verification_id" ref="verificationUpload" :data-eid="props.item.verification_id"
                                  :destroyDropzone="false"
                                  :duplicateCheck="true"
                                  :options="options"
                                  @vdropzone-file-added="vFileAdded"
                                  @vdropzone-sending="vsending"
                                  @vdropzone-error="verror"
                                  @vdropzone-removed-file="vremoved"
                                  @vdropzone-total-upload-progress="vTotalUploadProgress">
                        </dropzone>
                    </template>
                    <template #modal-footer="{ ok, cancel, hide }">
                        <o-button :loading="saving" native-type="button" variant="secondary"
                                  @click="clearFiles" v-if="noOfFiles">
                            {{ $t('sandoz.reset') }}
                        </o-button>
                        <o-button :loading="saving" native-type="button" variant="primary" @click="saveAndCloseAllowed()">
                            {{ $t('sandoz.save_and_close') }}
                        </o-button>
                    </template>
                </b-modal>

                <b-modal id="modal-deny" ref="denyModel" :ok-only="true" :ok-title="$t('core.cancel')" size="md"
                         :title="$t('sandoz.deny')" @close="closeDenyModel">
                    <o-textarea v-model="note" :label="$t('core.note')"></o-textarea>
                    <template #modal-footer="{ ok, cancel, hide }">
                        <o-button :loading="saving" native-type="button" variant="primary"
                                  @click="saveAndCloseDenied(props.item.verification_id)">
                            {{ $t('sandoz.save_and_close') }}
                        </o-button>
                    </template>
                </b-modal>
                <o-silentbox :gallery="pictures" :lazy-loading="true" class="silentbox-overlay-only" ref="verificationSilentBox">
                </o-silentbox>
            </template>
        </o-table>

        <b-modal id="modal-delivery" ref="deliveryModel" :ok-only="true" :ok-title="$t('core.close')"
                 :title="$t('sandoz.deliveries')" size="md" @close="closeDeliveryModel">
            <template
                v-if="selectedItem.contract_line && selectedItem.contract_line.data && selectedItem.contract_line.data.deliveries && selectedItem.contract_line.data.deliveries.data">
                <div class="row justify-content-start border-bottom pb-1 pt-1 font-weight-bold ml-1 mr-1">
                    <div class="col-sm pb-1 pl-0">{{ $t('sandoz.planned_delivery') }}</div>
                    <div class="col-sm pb-1 pl-0 pr-0">{{ $t('sandoz.quantity') }}</div>
                </div>
                <div v-for="(delivery) in selectedItem.contract_line.data.deliveries.data"
                     class="row justify-content-start border-top pb-1 pt-1 ml-1 mr-1">
                    <div class="col-sm pb-1 pl-0">{{ delivery.planned_delivery | formatDate }}</div>
                    <div class="col-sm pb-1 pl-0 pr-0">{{ delivery.quantity }}</div>
                </div>
            </template>
        </b-modal>
        
        <o-action-toolbar>
            <div class="d-flex w-100">
                <o-button variant="outline-primary" @click.prevent="$router.push({name: 'verifications.new_verifications'})">
                    {{$t('core.back')}}
                </o-button>
            </div>
        </o-action-toolbar>
    </div>
</template>

<style>
.dropzone {
    padding: 0;
}

.dz-image img {
    max-width: 100%;
}

@media (max-width: 768px) {
    .verificationNew table, .verificationNew thead, .verificationNew tbody, .verificationNew th, .verificationNew td, .verificationNew tr {
        display: block;
        width: 100%;
    }
    .verificationNew thead {
        display: none;
    }
    .verificationNew tr {
        margin-bottom: 10px;
        border: 1px solid #ddd;
    }
    .verificationNew td {
        display: flex;
        justify-content: space-between;
    }
    .verificationNew td:last-child {
        border-bottom: none;
    }
    .verificationNew td::before {
        content: attr(data-label);
        font-weight: bold;
        text-transform: capitalize;
    }
}
</style>

<script>
import axios from 'axios'
import Dropzone from 'nuxt-dropzone'
import 'nuxt-dropzone/dropzone.css'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import OSilentbox from "../../components/silentbox/components/gallery.vue";
import moment from 'moment'

export default {
    data() {
        return {
            findingLocation: false,
            latitude: null,
            longitude: null,
            error: null,
            status: [],
            defaultFilter: [],
            saving: false,
            note: null,
            options: {},
            verification: null,
            dateStatus: [],
            pictures: [],
            noOfFiles: 0,
            // deliveryDelay: [],
            selectedItem: {},
            metaData: null,
            verification_address: null,
            is_kam: null,
            types: [],
            locationFarAway: false,
            validToPast: false
        }
    },
    created() {
        this.getGeoLocation()
        this.options = {
            url: '/api/verifications/upload-picture',
            uploadProgress: true,
            progress: true,
            paramName: 'image',
            resizeWidth: 1280,
            resizeHeight: 720,
            thumbnailWidth: 175,
            thumbnailHeight: 175,
            addRemoveLinks: true,
            acceptedFiles: '.png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx,.zip,.eml,.msg',
            maxFiles: 1,
            resizeMethod: 'contain',
            resizeQuality: 1,
            dictDefaultMessage: this.$i18n.t('sandoz.drop_files'),
            maxFilesize: 1024
        }

        this.status = [
            {value: 'pending', text: this.$i18n.t('sandoz.pending')},
            {value: 'verified', text: this.$i18n.t('sandoz.verified')},
            {value: 'failed', text: this.$i18n.t('sandoz.failed')}
        ]

        this.dateStatus = [
            {value: 'current', text: this.$i18n.t('sandoz.current')},
            {value: 'current_and_future', text: this.$i18n.t('sandoz.current_future')},
            {value: 'future', text: this.$i18n.t('sandoz.future_date')},
            {value: 'past', text: this.$i18n.t('sandoz.past_date')},
        ]

        this.defaultFilter = [{
            column: 'status',
            displayValue: this.$i18n.t('sandoz.pending'),
            title: this.$i18n.t('sandoz.status'),
            value: 'pending'
        },{
          column: 'planned_verification',
          displayValue: this.$i18n.t('sandoz.current_future'),
          title: this.$i18n.t('sandoz.date'),
          value: 'current_and_future'
        }]

        

        // this.deliveryDelay = [
        //     { value: 'yes', text: this.$i18n.t('sandoz.yes') },
        //     { value: 'no', text: this.$i18n.t('sandoz.no') }
        // ]

        this.types = [
            { value: 'kam', text: this.$i18n.t('sandoz.kam') },
            { value: 'others', text: this.$i18n.t('sandoz.icepeak_or_edu') }
        ]

        this.getGeoLocation()

        
    },
    mounted() {
        Dropzone.autoDiscover = false
    },
    components: {
        OSilentbox,
        Dropzone
    },
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    methods: {
        openAllowModel(item) {
            this.locationFarAway = false
            this.validToPast = false

            this.verification = item.verification_proof_id
            this.verification_address = item.address_id
            this.note = item.note
            this.is_kam = this.checkContractType(item.contract_type)
            if (item && item.product &&
                item.product.data &&
                item.product.data.productMaster &&
                item.product.data.productMaster.data
            ) {
                this.options.maxFiles = 1000
            }

            var distance = this.metaData.contract.distance

            if(distance !== null) {
                distance = parseInt(distance * 1000)
                if(distance > 100) {
                    this.locationFarAway = true
                }
            }

            if(item.planned_to !== null && item.planned_to !== '') {
                if( moment(moment(item.planned_to).format('YYYY-MM-DD')).isBefore(moment().format('YYYY-MM-DD'))) {
                    this.validToPast = true
                }
            }
            this.$refs.allowModel.show()
        },
        closeAllowModel() {
            this.verification = null
            this.verification_address = null
            this.is_kam = null
            this.$refs.allowModel.hide()
        },
        openDenyModel(item) {
            this.verification = item.verification_proof_id
            this.verification_address = item.address_id
            this.note = item.note
            this.is_kam = this.checkContractType(item.contract_type)
            this.$refs.denyModel.show()
        },
        closeDenyModel() {
            this.verification = null
            this.verification_address = null
            this.note = null
            this.is_kam = null
            this.$refs.denyModel.hide()
        },
        saveAndCloseDenied() {
            var self = this

            if (!self.note || (typeof self.note === 'string' && !self.note.toString().trim().length)) {
                self.$notify({
                    title: self.$i18n.t('core.validation_error'),
                    text: self.$i18n.t('core.validation_error_text', {
                        message: self.$i18n.t('sandoz.empty_note_error_msg')
                    }),
                    type: 'error'
                })
                return false
            }

            self.saving = true
            var data = { id: this.verification, note: self.note, is_kam: this.is_kam, address_id: this.verification_address }
            axios.post('/api/verifications/deny', data).then((response) => {
                self.saving = false
                self.$notify({
                    title: self.$i18n.t('core.saved'),
                    text: self.$i18n.t('sandoz.verification_denied')
                })
                self.$refs['controls_' + this.verification].innerHTML = '<span class="badge badge-warning">' + self.$i18n.t('sandoz.failed') + '</span>'
                self.closeDenyModel()
            }).catch((error) => {
                self.saving = false
                if ('data' in error.response && 'message' in error.response.data) {
                    self.$notify({
                        title: self.$i18n.t('core.validation_error'),
                        text: self.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
                        type: 'error'
                    })
                } else {
                    self.$notify({
                        title: self.$i18n.t('core.save_error'),
                        text: self.$i18n.t('core.save_error_text', {url: ''}),
                        type: 'error'
                    })
                }
                self.closeDenyModel()
            })
        },
        getGeoLocation() {
            // this allows us to open the verification list with ?debug at the end of the URL
            // even on a local server with http:// geoLocation would otherwise only be available
            // if we are using https. With this option we can get past the geolcation
            if ('debug' in this.$route.query) {
                this.latitude = 42
                this.longitude = 7
                this.error = null
                this.findingLocation = false
                return
            }
            if (!('geolocation' in navigator)) {
                this.error = 'Geolocation is not supported by your browser'
                this.latitude = null
                this.longitude = null
                this.findingLocation = false
                return
            }
            this.findingLocation = true

            navigator.geolocation.getCurrentPosition(position => {
                if (position.coords === undefined) {
                    this.error = 'Geolocation service failed'
                    this.latitude = null
                    this.longitude = null
                    this.findingLocation = false
                } else {
                    this.latitude = position.coords.latitude
                    this.longitude = position.coords.longitude
                    this.error = null
                }
                this.findingLocation = false
            }, error => {
                if (error.code === 1) {
                    this.error = 'Geolocation blocked, please unblock'
                } else {
                    this.error = error.message
                }
                this.latitude = null
                this.longitude = null
                this.findingLocation = false
            }, {
                // enableHighAccuracy: true,
                // timeout: 5000,
                // maximumAge: 0
            })
        },
        vremoved(file, xhr, error) {
            this.saving = true
            let name = null
            if (typeof file.xhr !== 'undefined' && typeof file.manuallyAdded === 'undefined') {
                name = JSON.parse(file.xhr.response)
            } else if (typeof file.manuallyAdded !== 'undefined' && file.manuallyAdded === true) {
                name = file.name
            }

            let param = {'image': name, 'id': this.verification, 'is_kam': this.is_kam}
            if (name !== null && !name?.error) {
                axios.post('/api/verifications/delete-picture', param).then((response) => {
                  this.noOfFiles = this.$refs.verificationUpload.dropzone.files.length
                  this.saving = false
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
        vsending(file, xhr, formData) {
            this.saving = true
            formData.append('id', this.verification)
            formData.append('contract', this.verification_address)
            formData.append('lat', this.latitude)
            formData.append('long', this.longitude)
            formData.append('is_kam', this.is_kam)
        },
        verror(file, message, xhr) {
            this.$refs.verificationUpload.removeFile(file)
            this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: message.message ? message.message : message,
                type: 'error'
            })
        },
        vFileAdded(file) {
          this.noOfFiles = this.$refs.verificationUpload.dropzone.files.length
        },
        vTotalUploadProgress(totaluploadprogress) {
            if(totaluploadprogress === 100) {
                this.saving = false
            }
        },
        saveAndCloseAllowed() {
            var self = this

            if((self.validToPast || self.locationFarAway) && (self.note === null || self.note === '') ) {
                self.saving = false
                self.$notify({
                    title: self.$i18n.t('core.save_error'),
                    text: self.$i18n.t('sandoz.note_required'),
                    type: 'error'
                })

                return false
            }

            self.saving = true
            var data = { id: this.verification, note: self.note, is_kam: this.is_kam, address_id: this.verification_address }
            axios.post('/api/verifications/allow', data).then((response) => {
                self.saving = false
                self.$notify({
                    title: self.$i18n.t('core.saved'),
                    text: self.$i18n.t('sandoz.verification_allow')
                })
                self.$refs['controls_' + this.verification].innerHTML = '<span class="badge badge-success">' + self.$i18n.t('sandoz.verified') + '</span>'
                self.closeAllowModel()
            }).catch((error) => {
                self.saving = false
                if ('data' in error.response && 'message' in error.response.data) {
                    self.$notify({
                        title: self.$i18n.t('core.validation_error'),
                        text: self.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
                        type: 'error'
                    })
                } else {
                    self.$notify({
                        title: self.$i18n.t('core.save_error'),
                        text: self.$i18n.t('core.save_error_text', {url: ''}),
                        type: 'error'
                    })
                }
                self.closeAllowModel()
            })
        },
        openDeliveryModel(item) {
            this.selectedItem = item
            this.$refs.deliveryModel.show()
        },
        closeDeliveryModel() {
            this.selectedItem = {}
            this.$refs.deliveryModel.hide()
        },
        showQuantity(line) {
            return !!(line && line.product &&
                line.product.data &&
                line.product.data.productMaster &&
                line.product.data.productMaster.data &&
                line.product.data.productMaster.data.show_quantity)
        },
        hasPermission(item) {
            let result = true
            let permissions = item
            let user = this.user
            if (!user.is_super_user && permissions) {
                permissions.forEach((permission) => {
                    if (!user.routePermissions.includes(permission)) {
                        result = false
                    }
                })
            }
            return result
        },
        openPictureOverlay (item) {

            var id = item.verification_proof_id
            var is_kam = this.checkContractType(item.contract_type)
            var address_id = item.address_id
            var self = this
            self.pictures = []

            var url = '/api/verifications/pictures/' + id
            if(is_kam === true) {
                url = '/api/verifications/pictures/' + id + '/' + is_kam + '/' + address_id
            }

            return axios
                .get(url)
                .then((response) => {
                    self.verificationPictures = response.data
                    if (self.verificationPictures && self.verificationPictures.length) {
                        self.verificationPictures.forEach(function (item) {
                            var orgSrc = '/verifications/' + id + '/' + item.picture
                            let src = orgSrc
                            var extension = item.picture.split('.').pop().toLowerCase();
                            let isImage = true
                            if(extension !== 'png' && extension !== 'jpg' && extension !== 'jpeg') {
                                if(extension === 'doc' || extension === 'docx') {
                                    extension = 'doc';
                                }
                                if(extension === 'xlsx' || extension === 'xls') {
                                    extension = 'xls';
                                }
                                if(extension === 'html' || extension === 'eml' || extension === 'txt' || extension === 'msg') {
                                    extension = 'html';
                                }
                                src = '/images/'+extension+'-icon.png'
                                isImage = false
                            }
                            self.pictures.push({
                                src: src,
                                alt: item.picture,
                                path: isImage ? null : orgSrc,
                                description: self.$i18n.t('sandoz.latitude') + ': ' +
                                    item.latitude + ', ' + self.$i18n.t('sandoz.longitude') + ': ' +
                                    item.longitude + ', ' + self.$i18n.t('sandoz.distance') + ': ' +
                                    (Vue.filter('formatDistance')(item.distance))
                            })
                        })
                        self.$refs.verificationSilentBox.openOverlay(self.pictures[0], 0)
                    } else {
                        self.$notify({
                          title: self.$i18n.t('core.error'),
                          text: self.$i18n.t('sandoz.picture_not_found'),
                          type: 'warning'
                        })
                    }
                })
                .catch((error) => {
                    self.$notify({
                        title: self.$i18n.t('core.error_alert_title'),
                        text: self.$i18n.t('core.error_alert_text'),
                        type: 'error'
                    })
                })
        },
        clearFiles () {
            this.$refs.verificationUpload.removeAllFiles()
        },
        pdfContract(contractID) {
            this.$root.$loading.start()
            axios.post('/api/sandoz/generate-pdf2', {id:contractID}, { responseType: 'arraybuffer' })
            .then((response) => {
                require('downloadjs')(
                    response.data,
                    'contract_' + contractID + '.pdf',
                    'application/pdf'
                )
                this.$root.$loading.finish()
            }).catch((error) => {
                this.$root.$loading.finish()
                console.log(error)
            })
        },
        setMeta(meta) {
            if(this.$route.params.kam === true && this.metaData === null  && Object.keys(meta.meta.contract.contracts).length > 1) {
                this.defaultFilter.push({
                    column: 'contract_type',
                    displayValue: this.$i18n.t('sandoz.kam'),
                    title: this.$i18n.t('sandoz.type'),
                    value: 'kam'
                })
            }

            if(this.$route.params.kam === false && this.metaData === null && Object.keys(meta.meta.contract.contracts).length > 1) {
                this.defaultFilter.push({
                    column: 'contract_type',
                    displayValue: this.$i18n.t('sandoz.icepeak_or_edu'),
                    title: this.$i18n.t('sandoz.type'),
                    value: 'others'
                })
            }
            
            this.metaData = meta.meta
        },
        checkContractType(type) {
            if(type.startsWith("KAM_") && type !== 'KAM_SD_EDU') {
                return true
            }
            return false
        },
        displayContractType(type) {
            if(type.startsWith("KAM_") && type !== 'KAM_SD_EDU') {
                return 'KAM'
            }else {
                if(type.endsWith("_EDU")) {
                    return 'Educational'
                } else {
                    return 'Ice-Peak'
                }
            }
        },
        isUpcoming: function (item) {
            if(item.status === 'upcoming') {
                return true
            }
        return false
        },
        isPast: function (item) {

            var today = moment().format('YYYY-MM-DD'); // Current date
            var fromDate = moment(item.planned_from).format('YYYY-MM-DD')
            var toDate = moment(item.planned_to).format('YYYY-MM-DD')

            today = new Date(today).getTime()
            fromDate = new Date(fromDate).getTime();
            toDate = new Date(toDate).getTime();

            if(today >= fromDate && today <= toDate) {
                return false
            }
            return true
        }
    }
}
</script>

<style lang="scss">
.contract_detail {
    label {
        font-weight: bold;
        margin-bottom: 0;
    }
}
.mwp-100 {
    max-width: 100px;
}
.mw-133 {
    max-width: 133px;
}
.mw-200 {
    max-width: 200px;
}
</style>
